import React, { useState } from 'react';
import { EvidenceRequirements } from '../common/BulletList';

export function UnitRequirements({ text }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;

  return (
    <div style={{ marginTop: 6 }}>
      <button
        className="btn-sm"
        style={{ fontSize: 10, padding: '3px 10px' }}
        onClick={() => setOpen(!open)}
      >
        {open ? '▾ Hide Requirements' : '▸ Show Requirements'}
      </button>
      {open && (
        <div style={{ marginTop: 8, padding: 10, background: 'var(--panel)', borderRadius: 4, border: '1px solid var(--border)' }}>
          <EvidenceRequirements text={text} />
        </div>
      )}
    </div>
  );
}
